/**
 * 认证相关的常量
 */
export const AUTH_CONSTANTS = {
  // 存储键名
  STORAGE_KEYS: {
    TOKEN: 'userToken',
    USER_INFO: 'userInfo'
  },
  
  // API路径
  API_PATHS: {
    VERIFY_TOKEN: '/newapi/user/verify-token',
    LOGOUT: '/newapi/user/logout',
    GET_SIGNATURE: '/newapi/wechat-jsapi/get-signuature'
  },
  
  // 微信登录
  WECHAT: {
    LOGIN_URL: 'https://identity.gdtvdv.com/wxlogin.html',
    TOKEN_PARAM: 'token',
    RETURN_URL_PARAM: 'return_url'
  },
  
  // 路由
  ROUTES: {
    LOGIN: '/login',
    HOME: '/'
  },
  
  // 事件名称
  EVENTS: {
    LOGIN_SUCCESS: 'auth:login-success',
    LOGOUT: 'auth:logout',
    AUTH_ERROR: 'auth:error'
  },
  
  // HTTP状态码
  HTTP_STATUS: {
    UNAUTHORIZED: 401
  }
}; 